export const isTouchDevice = (): boolean => {
  if ('maxTouchPoints' in navigator) {
    return window.navigator.maxTouchPoints > 0
  }
  if ('msMaxTouchPoints' in navigator) {
    return window.navigator.msMaxTouchPoints > 0
  }
  const mQ = window.matchMedia('(pointer:coarse)')
  if (mQ && mQ.media === '(pointer:coarse)') {
    return !!mQ.matches
  }
  return false
}
